import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { plantInfo } from 'models';
import { RootState } from '../../../app/store';
export interface sidebarState {
  loading: boolean;
  error?: string;
  plantSelected: string | null;
  inverterSelected: string | null;
  sidebarList: plantInfo[];
}

const initialState: sidebarState = {
  loading: false,
  sidebarList: [],
  plantSelected: null,
  inverterSelected: null,
  error: undefined,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setPlantItemSidebarList(state, action: PayloadAction<string | null>) {
      state.plantSelected = action.payload;
      state.inverterSelected = null;
    },
    setInverterItemSidebarList(state, action: PayloadAction<string | null>) {
      state.inverterSelected = action.payload;
    },
    fetchSidebarList(state, action: PayloadAction<string>) {
      state.loading = true;
    },
    fetchSidebarListSuccess(state, action: PayloadAction<plantInfo[]>) {
      state.loading = false;
      state.sidebarList = action.payload;
    },
    fetchSidebarListFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const sidebarActions = sidebarSlice.actions;

export const selectSidebarError = (state: RootState) => state.sidebarReducer.error;
export const selectSidebarLoading = (state: RootState) => state.sidebarReducer.loading;
export const selectSidebarList = (state: RootState) => state.sidebarReducer.sidebarList;
export const selectPlantItemSidebar = (state: RootState) => state.sidebarReducer.plantSelected;
export const selectInverterItemSidebar = (state: RootState) =>
  state.sidebarReducer.inverterSelected;

const sidebarReducer = sidebarSlice.reducer;
export default sidebarReducer;
